import styled from 'styled-components';
import { flex } from '../../../styles/mixins';

export const CreateTagView = styled.div`
	.ant-form-item-label label,
	.up-title {
		color: #8d95a3 !important;
	}
	.tips-red {
		color: #ff4d4f;
	}
	.up-title {
		margin-bottom: 10px;
		.up-tips {
			font-size: 10px;
		}
	}

	.up-icon {
		cursor: pointer;
		height: 50px;
		width: 50px;
		border: 1px dashed #eeeff1;
		border-radius: 50%;
		position: relative;
		${flex('row', 'center', 'center')}
		&:hover {
			.del {
				display: block;
			}
		}
		> .logo {
			border-radius: 50%;
			width: 100%;
			height: 100%;
		}
		> .del {
			display: none;
			position: absolute;
			top: 0;
			right: 0;
		}
	}
`;
